/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import { DrinkTypes } from 'types/DrinkTypes'
import styles from './styles.module.scss'
import 'intl-pluralrules'
import { Locale } from 'contexts/locale'
import { setFemale, setNumber } from 'stores/consumption'
import { Consumption, Dispatch } from 'contexts/consumption'

export function Calculator() {
  const locale = useContext(Locale)
  const consumption = useContext(Consumption)
  const allDrinks = Object.values(consumption.drinks)
  const [showResults, setShowResults] = useState(false)
  const dispatch = useContext(Dispatch)
  const messages = require('./locales/' + locale + '.yml')
  const onBlurHandler = () => setShowResults(true)

  const activeButtonClasses = 'primary active'
  return (
    <div className={`ui form ${styles.calculator}`}>
      <div className={`field ${styles.centered}`}>
        <div className='ui compact buttons'>
          <div
            className={`ui ${
              !consumption.isFemale ? activeButtonClasses : ''
            } button`}
            onClick={() => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: 'setMale'
              })
              dispatch(setFemale(false))
            }}
          >
            <i className='mars icon' />
            Mann
          </div>
          <div
            className={`ui ${
              consumption.isFemale ? activeButtonClasses : ''
            } button`}
            onClick={() => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: 'setFemale'
              })
              dispatch(setFemale(true))
            }}
          >
            <i className='venus icon' />
            Frau
          </div>
        </div>
      </div>

      <h3
        className={styles.label}
        dangerouslySetInnerHTML={{ __html: messages.header }}
      />
      <div className={styles.fields}>
        {Object.values(DrinkTypes).map(drinkType => {
          if (drinkType === 'Other') {
            return null
          }
          return (
            <div key={drinkType} className={styles.fieldContainer}>
              <div className={styles.image}>
                <img alt='' src={require('images/' + drinkType + '.svg')} />
              </div>
              <div className={'fluid field ' + styles.field}>
                <label
                  htmlFor={`form-field-${drinkType}`}
                  className={styles.fieldLabel}
                  dangerouslySetInnerHTML={{
                    __html: messages.drinktype.label[drinkType]
                  }}
                />
                <input
                  id={`form-field-${drinkType}`}
                  name={drinkType}
                  type='number'
                  min={0}
                  value={consumption.drinks[drinkType as DrinkTypes]}
                  onChange={event => {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'Interactions',
                      event_action: 'input',
                      event_label: drinkType
                    })
                    dispatch(
                      setNumber(
                        parseInt(event.currentTarget.value, 10),
                        drinkType
                      )
                    )
                  }}
                  onBlur={onBlurHandler}
                />
              </div>
            </div>
          )
        })}
      </div>

      {showResults && (
        <div className='ui fluid container center aligned'>
          <i
            className={`chevron down large grey icon ${styles.bounceAnimation}`}
          />
        </div>
      )}
    </div>
  )
}
